module.exports = __webpack_public_path__ + "img/icons8-image.f0296b5d.svg";